import { logWarn } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

import type { InteractionEventData } from '@web-platform/shared-universal-types-tracking/src/trackInteractionEvent/trackInteractionEvent';

export const updateEventNumbers = (event: InteractionEventData) => {
  const { numbers = {}, ...rest } = event;

  if (Object.keys(numbers).length === 0) return event;

  // Rounding numbers to ensure they are suitable for uint32 used by Slipstream
  Object.entries(numbers).forEach(([key, value]) => {
    const roundValue = Math.round(value);
    if (value !== roundValue) {
      logWarn({
        component: 'Tracking',
        message: `Non-integer numbers value found for event ${event.name}, key ${key}. Using Math.round to avoid Slipstream errors.`,
      });
    }
    numbers[key] = roundValue;
  });

  return {
    ...rest,
    numbers,
  };
};
